import { Component } from "react";
import * as React from "react";
import { fetchEventPointsLeaderboard } from "../../services/ApiContext";
import Header from "../../components/Header/Header";
import Menu from "../../components/Menu/Menu";
import PageContainer from "../../containers/PageContainer";
import EconomyDataInterface from "../../objects/EconomyDataInterface";
import { resolveRankByString } from "../../utils/Badges";
import { Link } from "react-router-dom";
import ContentLoading from "../../components/Others/ContentLoading";

class EventPointsLeaderboard extends Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			apiData: null
		};
	}

	public async componentDidMount() {
		const apiData = await fetchEventPointsLeaderboard();
		this.setState({
			apiData: apiData
		});
	}

	public render() {
		if (this.state.apiData === null) {
			return (
				<PageContainer>
					<Header/>
					<main id="main-container">
						<Menu/>
						<div className="content content-full">
							<div
								className="col-xl-12 col-md-12 col-sm-12 text-xl-center text-md-center text-sm-center pt-lg-9 pb-lg-10">
								<ContentLoading/>
							</div>
						</div>
					</main>
				</PageContainer>
			);
		}
		return (
			<PageContainer>
				<Header/>
				<main id="main-container">
					<Menu/>
					<div className="content content-full">
						<h1>Leaderboard hráčů s nejvyšším bodů za vyhrané Eventy</h1>
						<div className="block block-rounded block-bordered">
							<div className="block-content block-content-full">
								<table className="table table-bordered table-striped table-vcenter js-dataTable-full">
									<thead>
									<tr>
										<th className="text-center" style={{width: '50px'}}>#</th>
										<th className="text-center" style={{width: '110px'}}>Rank</th>
										<th>Nick</th>
										<th className="d-none d-sm-table-cell text-center"
											style={{width: '200px'}}>EventPoints
										</th>
									</tr>
									</thead>
									<tbody>
									{this.generateTable()}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</main>
			</PageContainer>
		);
	}

	public generateTable() {
		const apiData = this.state.apiData as EconomyDataInterface[];
		let finalTable: any = [];
		apiData.forEach((player: EconomyDataInterface) => {
			if (player.groups !== null) {
				finalTable.push(
					<tr key={player.index}>
						<td className="text-center">{player.index}</td>
						<td className="text-center">{resolveRankByString(player.groups!.primary)}</td>
						<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
						<td className="text-center">{player.value}</td>
					</tr>
				);
			} else {
				finalTable.push(
					<tr key={player.index}>
						<td className="text-center">{player.index}</td>
						<td className="text-center">{resolveRankByString('hrac')}</td>
						<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
						<td className="text-center">{player.value}</td>
					</tr>
				);
			}
		});
		return finalTable;
	}

}

export default EventPointsLeaderboard;
